<template>
    <!--
        作者：bbc_team
        时间：2023-06-08
        描述：插件中心-直播-直播房间
    -->
    <div class="list">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input v-model="searchForm.search" size="small" placeholder="请输入用户名和真实姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="searchSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!--内容-->
        <div class="goods-content">
            <div class="table-wrap">
                <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                    <el-table-column prop="name" label="标题">
                        <template slot-scope="scope">
                            <div class="text-ellipsis"> <span v-if="scope.row.is_top == 1" class="red">[置顶]</span>{{ scope.row.name }} </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="share_img_id" label="封面" width="120">
                        <template slot-scope="scope">
                            <div v-if="scope.row.share_img_id > 0" class="picture-box d-c-c">
                                <img :src="scope.row.share.file_path" alt="封面" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status_text" label="直播状态"></el-table-column>
                    <el-table-column prop="status_text" label="开播时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.live_status == 103 || scope.row.live_status == 101" class="fb green">
                                {{ scope.row.real_start_time_text }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status_text" label="结束时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.live_status == 103" class="fb green">
                                {{ scope.row.real_end_time_text }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="房间状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.is_delete == 1" class="fb red">隐藏</span>
                            <span v-if="scope.row.is_delete == 0" class="fb green">显示</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="anchor_name" label="主播名" width="70">
                        <template slot-scope="scope">
                            <div class="user-info d-s-c">
                                <span class="ml10">{{ scope.row.user.nickName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="数据统计" width="150">
                        <template slot-scope="scope">
                            <div>观看人数：{{ scope.row.view_num }}</div>
                            <div>礼物收入：{{ scope.row.gift_num }}</div>
                            <div>订单数量：{{ scope.row.sales_num }}</div>
                            <div>点赞数量：{{ scope.row.digg_num }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="120"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button v-auth="'/live/room/edit'" type="text" size="small" @click="editClick(scope.row)">修改</el-button>
                            <el-button v-auth="'/live/room/user_gift'" type="text" size="small" @click="showGift(scope.row)">礼物排行</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>

        <!--查看房间商品-->
        <Goods :is_open="open_goods" :cur-model="curModel" @close="closeGoods"></Goods>

        <!--编辑-->
        <Edit :open="open_edit" :form="curModel" @close="closeEdit"></Edit>

        <!--查看房间礼物排行-->
        <Gift :is_open="open_gift" :cur-model="curModel" @close="closeGift"></Gift>
    </div>
</template>

<script>
    import liveApi from "@/api/live.js";
    import Goods from "./dialog/Goods.vue";
    import Edit from "./dialog/Edit.vue";
    import Gift from "./dialog/Gift.vue";
    export default {
        components: {
            Goods,
            Edit,
            Gift
        },
        inject: ["reload"],
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*横向表单数据模型*/
                searchForm: {
                    search: ""
                },
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*编辑对象*/
                curModel: {},
                /*是否打开商品*/
                open_goods: false,
                /*是否审核*/
                open_audit: false,
                /*是否打开礼物*/
                open_gift: false
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*搜索*/
            searchSubmit() {
                this.curPage = 1;
                this.getTableList();
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = {
                    page: self.curPage,
                    list_rows: self.pageSize,
                    username: self.searchForm.search
                };

                liveApi
                    .getRoom(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {});
            },

            /*删除分类*/
            deleteClick(row) {
                let self = this;
                self.$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    liveApi
                        .deleteRoom({
                            room_id: row.room_id
                        })
                        .then((data) => {
                            self.$message({
                                message: "删除成功",
                                type: "success"
                            });
                            self.getTableList();
                        });
                });
            },

            /*查看商品*/
            showGoods(item) {
                this.curModel = item;
                this.open_goods = true;
            },

            /*关闭商品*/
            closeGoods() {
                this.open_goods = false;
            },

            /*查看礼物*/
            showGift(item) {
                this.curModel = item;
                this.open_gift = true;
            },

            /*关闭礼物*/
            closeGift() {
                this.open_gift = false;
            },
            /*打开编辑*/
            editClick(e) {
                this.curModel = e;
                this.open_edit = true;
            },

            /*关闭编辑*/
            closeEdit() {
                this.open_edit = false;
                this.getTableList();
            }
        }
    };
</script>

<style scoped="scoped">
    .picture-box {
        width: 50px;
        height: 50px;
    }

    .picture-box img {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }

    .user-info img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/live/room/room.vue